import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import HelpMessage from "./HelpMessage";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import moment from "moment";
import axios from "axios"; // Import Axios

const AddSubnote = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { id } = useParams();

  const { note } = location.state || {}; // Retrieve note data from location state

  const [notes, setNotes] = useState(""); // State to hold the notes

  const [fieldData, setFieldData] = useState({
    noteId: id,
  });

  // Get the current date in the specified format
  const currentDate = moment(new Date()).format("DD/MM/YYYY");

  // Get the supplier ID from local storage
  const currentUserSupplierID = localStorage.getItem("currentUser");

  // Function to handle form submission
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    // Check if notes are not empty before sending the API request
    if (fieldData.notes.trim() === "" ) {
      alert("Notes cannot be empty.");
      return;
    }

    // Prepare the data to be sent to the server
    const dataToSave = {
      note: fieldData.notes,
      createddate: fieldData.createddate,
      supplier: note.supplier.trim(),
      parentNoteId: note.Id,
      indexkey: note.indexkey
    };

    console.log(note);

    // Make the API request to save the data
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_BASEURL + "/api/subnote",
        dataToSave,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          }
        }
      );
      // Redirect to the Notes page after saving
      navigate("/Notes/EditNotes", { state: { note: note } });
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };

  return (
    <>
      <div className="container-login100">
        <div className="wrap-login100">
          <Navbar />
          <div className="tableft">
            <a>Notes</a>
          </div>
          <div className="" id="result-wrapper">
            <div className="rp-flex" id="search">
              <div className="col-md-12">
                <a className="search-custom">
                  <i className="mr-15 fas fa-search" />
                  <span className="mr-0">Search</span>
                </a>
              </div>
            </div>

            <form id="frmNotes" name="Notes" noValidate>
              <div className="margin_tops notes-wrap" id="result-wrappers">
                <input defaultValue="0" name="Id" type="hidden" />

                <input name="Indexkey" type="hidden" />

                <div className="row">
                  <div className="col-sm-3 form-group">
                    <label >
                      CREATED DATE
                      <span className="req-error"> *</span> :
                    </label>

                    <input
                      className="form-control"
                      defaultValue={currentDate}
                      disabled
                      id="createdDate"
                      type="text"
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12 form-group">
                    <label>
                      NOTES <span className="req-error">*</span> :
                    </label>

                    <textarea
                      className="form-control"
                      value={fieldData.notes}
                      onChange={(e) => {
                        setFieldData( {
                          ...fieldData,
                          notes: e.target.value
                        })
                      }}
                      maxLength="99"
                      name="Notes"
                      rows="5"
                      style={{
                        width: "100%",
                      }}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12"></div>
                </div>

                <div className="save-cancle-btn-wrap">
                  <div className="row save-cancle-btn-wrap">
                    <div className="col-lg-2 col-md-2">
                      <button
                        className="btn  btn-lg btn-primary"
                        onClick={handleFormSubmit}
                      >
                        <span className="glyphicon glyphicon-floppy-disk"></span>
                        &nbsp;&nbsp;&nbsp;
                        <span>SAVE</span>
                      </button>
                    </div>

                    <div className="col-lg-2 col-md-2">
                      <button
                        className="btn btn-lg btn-default"
                        type="button"
                        onClick={() => {
                          navigate("/Notes/EditNotes", { state: { note: note } });
                        }}
                      >
                        <span className="glyphicon glyphicon-remove"></span>
                        &nbsp;&nbsp;&nbsp;
                        <span>CANCEL</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <HelpMessage />
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddSubnote;
